import {
  EmployeeConfirmPreparationInput,
  EmployeeConfirmPreparationMutation,
  EmployeeConfirmPreparationMutationVariables,
} from './../../../types'
import { EMPLOYEE_CONFIRM_PREPARATION } from './../Queries'
import { client } from '../../..'

export const employeeConfirmPreparation = async (meetingId: string, input: EmployeeConfirmPreparationInput): Promise<void> => {
  await client.mutate<EmployeeConfirmPreparationMutation, EmployeeConfirmPreparationMutationVariables>({
    mutation: EMPLOYEE_CONFIRM_PREPARATION,
    variables: {
      meetingId: meetingId,
      input,
    },
    update: (_store, { data }) => {
      if (!data || !data.employeeConfirmPreparation) {
        throw new Error('Invalid UpdateMeetingFeedback mutation')
      }
    },
  })
}
